import { v4 as uuidv4 } from 'uuid';

export class SelectItem {
  uuid: string = uuidv4();

  name?: string; // Picture Check などに表示する名前

  key?: string; // 返信グループの出し分け条件用のkey

  backgroundImage?: string;

  limitedMCC? : boolean; // MCC限定

  constructor(init?: Partial<SelectItem>) {
    Object.assign(this, init);

    if (!this.uuid) {
      this.uuid = uuidv4();
    }
  }
}
